import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsOptionsOpenedOrdersEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/options/columns-options-opened-orders.enum'

export const ColumnsOptionsOpenedOrdersConstant: ColumnInterface<ColumnsOptionsOpenedOrdersEnum>[] = [
	{
		column: ColumnsOptionsOpenedOrdersEnum.tickerCompany,
		visible: true,
	},
	{
		column: ColumnsOptionsOpenedOrdersEnum.operation,
		visible: true,
	},
	{
		column: ColumnsOptionsOpenedOrdersEnum.quantity,
		visible: true,
	},
	{
		column: ColumnsOptionsOpenedOrdersEnum.orderType,
		visible: true,
	},
	{
		column: ColumnsOptionsOpenedOrdersEnum.price,
		visible: true,
	},
	{
		column: ColumnsOptionsOpenedOrdersEnum.term,
		visible: true,
	},
	{
		column: ColumnsOptionsOpenedOrdersEnum.statusTitle,
		visible: true,
	},
]
